import React from 'react';
import { SEOHeadUnfallgutachten } from '../components/SEOHeadUnfallgutachten';
import { Header } from '../components/Header';
import { HeroUnfallgutachten } from '../components/unfallgutachten/HeroUnfallgutachten';
import { DefinitionBox } from '../components/unfallgutachten/DefinitionBox';
import { WannBrauchen } from '../components/unfallgutachten/WannBrauchen';
import { AblaufSection } from '../components/unfallgutachten/AblaufSection';
import { KostenSection } from '../components/unfallgutachten/KostenSection';
import { VergleichSection } from '../components/unfallgutachten/VergleichSection';
import { BundesweitSection } from '../components/unfallgutachten/BundesweitSection';
import { FahrzeugArtenSection } from '../components/unfallgutachten/FahrzeugArtenSection';
import { VertrauenSection } from '../components/unfallgutachten/VertrauenSection';
import { MiniGlossar } from '../components/unfallgutachten/MiniGlossar';
import { FAQUnfallgutachten } from '../components/unfallgutachten/FAQUnfallgutachten';
import { AbschlussSection } from '../components/unfallgutachten/AbschlussSection';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';

const UnfallgutachtenPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHeadUnfallgutachten />
      <Header />
      <main>
        <HeroUnfallgutachten />
        <DefinitionBox />
        <WannBrauchen />
        <AblaufSection />
        <KostenSection />
        <VergleichSection />
        <BundesweitSection />
        <FahrzeugArtenSection />
        <VertrauenSection />
        <MiniGlossar />
        <FAQUnfallgutachten />
        <AbschlussSection />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default UnfallgutachtenPage;